import React, { useState, useEffect } from "react";
import { Row, Col, Button, Steps, Select, message } from "antd";
import { useHistory } from "react-router-dom";
import { fireConfetti } from "@utils/confetti";
import { saveUserOnboardingData } from "@api/user/user";
import logo from "@assets/images/logo/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "@redux/actions/authActions";
import { FiLogOut } from "react-icons/fi";

const { Step } = Steps;

// Step 1
const industry = [
  {
    id: 1,
    name: "Technology",
  },
  {
    id: 2,
    name: "Healthcare",
  },
  {
    id: 3,
    name: "Education",
  },
  {
    id: 4,
    name: "Finance",
  },
  {
    id: 5,
    name: "Retail",
  },
  {
    id: 6,
    name: "Manufacturing",
  },
  {
    id: 7,
    name: "Other",
  },
];

const department = [
  {
    id: 0,
    name: "I'm a Student",
  },
  {
    id: 1,
    name: "Engineering",
  },
  {
    id: 2,
    name: "Marketing",
  },
  {
    id: 3,
    name: "Human Resources",
  },
  {
    id: 4,
    name: "Sales",
  },
  {
    id: 5,
    name: "Finance",
  },
  {
    id: 6,
    name: "Operations",
  },
  {
    id: 7,
    name: "Other",
  },
];

// Step 2
const categories = [
  "Search",
  "Email",
  "Writing",
  "Blog",
  "Ads",
  "Marketing",
  "Sales",
  "All of these",
];

const Onboarding = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [current, setCurrent] = useState(0);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);

  // Handle logout
  const handleLogout = () => {
    // Dispatch logout action
    dispatch(logoutAction());
  };

  // Handle skip click (new function)
  const handleSkip = () => {
    if (current < steps.length - 1) {
      setCurrent(current + 1);
    } else {
      // Handle the final step if needed, similar to handleOnboardingCompletion
      handleOnboardingCompletion();
    }
  };

  // Onboarding Steps
  const steps = [
    {
      content: (
        <Col span={24} style={{ marginTop: -32 }}>
          <h3 className="hp-mb-16">Tell us about your business</h3>
          <p className="hp-mb-32">You will be up and running in no time</p>

          {/* Select Industry Dropdown */}
          <Select
            className="hp-mb-16"
            placeholder="Select your industry"
            style={{ width: 200, marginRight: 8 }}
            onChange={(value) => setSelectedIndustry(value)}
            value={selectedIndustry}
          >
            <Select.Option value="">Select your industry</Select.Option>
            {industry.map((index) => (
              <Select.Option key={index.id} value={index.name}>
                {index.name}
              </Select.Option>
            ))}
          </Select>

          {/* Select Department Dropdown */}
          <Select
            className="hp-mb-16"
            placeholder="Select your department"
            style={{ width: 200, marginRight: 8 }}
            onChange={(value) => setSelectedDepartment(value)}
            value={selectedDepartment}
          >
            <Select.Option value="">Select your department</Select.Option>
            {department.map((index) => (
              <Select.Option key={index.id} value={index.name}>
                {index.name}
              </Select.Option>
            ))}
          </Select>

          {/* Select Number of Employees Dropdown */}
          <Select
            className="hp-mb-16"
            placeholder="Select number of employees"
            style={{ width: 200 }}
            onChange={(value) => setSelectedEmployees(value)}
            value={selectedEmployees}
          >
            <Select.Option value="">Select number of employees</Select.Option>
            <Select.Option value="1">1</Select.Option>
            <Select.Option value="2-50">2 - 50</Select.Option>
            <Select.Option value="51-100">51 - 100</Select.Option>
            <Select.Option value="101-500">101 - 500</Select.Option>
            <Select.Option value="501-1000">1000+</Select.Option>
          </Select>
        </Col>
      ),
    },
    {
      content: (
        <Col span={24} style={{ marginTop: -32 }}>
          <h3 className="hp-mb-16">How do you plan on using Copilotly</h3>
          <p className="hp-mb-16">
            Select all that apply. You can change this later at any time.
          </p>

          {/* Select Categories Card */}
          {/* Place 5 categories on the first row and 3 on the second */}
          <Row gutter={[24, 24]} className="hp-mb-16">
            {categories.slice(0, 5).map((name, index) => (
              <Row key={index}>
                <Button
                  type="primary"
                  className="hp-btn-outline hp-hover-bg-primary-1"
                  style={{
                    width: 120,
                    marginRight: 20,
                    backgroundColor: selectedCategories.includes(name)
                      ? "#2F59F7"
                      : "#fff",
                    color: selectedCategories.includes(name)
                      ? "#fff"
                      : "#2F59F7",
                  }}
                  onClick={() => {
                    if (selectedCategories.includes(name)) {
                      setSelectedCategories(
                        selectedCategories.filter((item) => item !== name)
                      );
                    } else {
                      setSelectedCategories([...selectedCategories, name]);
                    }
                  }}
                >
                  {name}
                </Button>
              </Row>
            ))}
          </Row>
          <Row gutter={[24, 24]} className="hp-mb-16" justify="center">
            {categories.slice(5, 8).map((name, index) => (
              <Row key={index}>
                <Button
                  type="primary"
                  className="hp-btn-outline hp-hover-bg-primary-1"
                  style={{
                    width: 120,
                    marginRight: 20,
                    backgroundColor: selectedCategories.includes(name)
                      ? "#2F59F7"
                      : "#fff",
                    color: selectedCategories.includes(name)
                      ? "#fff"
                      : "#2F59F7",
                  }}
                  onClick={() => {
                    if (selectedCategories.includes(name)) {
                      setSelectedCategories(
                        selectedCategories.filter((item) => item !== name)
                      );
                    } else {
                      setSelectedCategories([...selectedCategories, name]);
                    }
                  }}
                >
                  {name}
                </Button>
              </Row>
            ))}
          </Row>
        </Col>
      ),
    },
    {
      content: (
        <Col span={24} style={{ marginTop: -32 }}>
          <h2 className="hp-mb-16">You're all set!</h2>

          <p
            className="hp-mb-32"
            style={{
              left: "25%",
              fontSize: "1.2rem",
            }}
          >
            Always use Copilotly AI
            <a
              href="https://app.copilotly.com/ethics"
              target="_blank"
              rel="noopener noreferrer"
              className="hp-text-color-primary-1 hp-mx-4 hp-text-color-dark-primary-2 hp-text-underline"
            >
              ethically and responsibly.
            </a>{" "}
            <br /> It is a powerful tool to help you become more efficient and
            productive, <br />
            however it should not be used recklessly.
          </p>
        </Col>
      ),
    },
  ];

  // Handle next click
  const next = () => {
    // Validate the current step
    if (current === 0) {
      if (!selectedIndustry || !selectedDepartment || !selectedEmployees) {
        message.error("Please select all the fields");
        return;
      }
    } else if (current === 1) {
      if (selectedCategories.length === 0) {
        message.error("Please select at least one category");
        return;
      }
    }
    setCurrent(current + 1);
  };

  // Handle previous click
  const prev = () => {
    setCurrent(current - 1);
  };

  // Fire confetti when the last step is opened
  useEffect(() => {
    if (current === steps.length - 1) {
      fireConfetti();
    }
  }, [current, steps.length]);

  // Handle onboarding completion
  const handleOnboardingCompletion = () => {
    // Construct the onboarding data
    const onboardingData = {
      about: [
        {
          industry: selectedIndustry,
          department: selectedDepartment,
          employeeCount: selectedEmployees,
        },
      ],
      categories: selectedCategories,
    };

    // Make an API call to save the onboarding data
    saveUserOnboardingData(onboardingData)
      .then(() => {
        // If user.currentPlan is "AppSumo", go to dashboard
        if (user?.appSumoUser) {
          history.push("/dashboard");
          return;
        }
        // Redirect to the /subscribe page
        history.push("/subscribe");
      })
      .catch((error) => {
        console.log("Save Onboarding Data Error: ", error);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <img
        className="hp-logo hp-mb-32"
        src={logo}
        alt="logo"
        style={{
          height: 80,
          width: "auto",
          backgroundColor: "transparent",
        }}
      />
      <h2 className="h1 hp-mb-32">Welcome to Copilotly</h2>

      {/* Steps Header */}
      <div className="hp-overflow-scroll hp-scrollbar-x-hidden">
        <Steps current={current}>
          {steps.map((index) => (
            <Step key={index} />
          ))}
        </Steps>
      </div>

      {/* Steps Content */}
      <div className="hp-text-center hp-p-80 hp-mt-6">
        {steps[current].content}
      </div>

      {/* Steps Footer */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: "10px",
            bottom: "10px",
          }}
        >
          <Button
            size="small"
            style={{}}
            onClick={handleLogout}
            icon={
              <FiLogOut
                style={{
                  marginRight: "5px",
                }}
              />
            }
          >
            Logout
          </Button>
        </div>

        <div style={{ textAlign: "center" }}>
          {current > 0 && (
            <Button className="hp-mx-8" onClick={() => prev()}>
              Previous
            </Button>
          )}

          {current < steps.length - 1 && (
            <>
              <Button type="primary" onClick={() => next()}>
                Next
              </Button>
              {/* Skip for now */}
              <p
                className="hp-text-underline hp-mt-16"
                onClick={handleSkip}
                style={{
                  display: "block",
                  marginTop: "10px",
                  color: "#2F59F7",
                  cursor: "pointer",
                }}
              >
                Skip for now
              </p>
            </>
          )}

          {current === steps.length - 1 && (
            <Button type="primary" onClick={() => handleOnboardingCompletion()}>
              Let's Go!
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
